import React from 'react';
import RotateIcon from 'components/icons/rotate';
import FlipIcon from 'components/icons/flip';
import ZoomInIcon from 'components/icons/zoom-in';
import ZoomOutIcon from 'components/icons/zoom-out';

import { Button } from 'components';

import cx from 'classnames';
import styles from './styles.scss';

export default class MomentEdit extends React.PureComponent {
  rotate = () => {
    const { orderId, momentId, transform } = this.props;
    const newRotate = ((transform.rotate || 0) - 90) / 360;
    const rotate = (newRotate - Math.floor(newRotate)) * 360;

    this.props.updateTransform(orderId, momentId, {
      rotate,
    });
  };

  flip = () => {
    const { orderId, momentId, transform } = this.props;

    this.props.updateTransform(orderId, momentId, {
      flip: !transform.flip,
    });
  };

  zoomIn = () => {
    const { orderId, momentId, transform } = this.props;
    if (transform.dpi < 100) return;
    this.props.updateTransform(orderId, momentId, {
      width: transform.width * 1.1,
    });
  };

  zoomOut = () => {
    const { orderId, momentId, transform } = this.props;
    this.props.updateTransform(orderId, momentId, {
      width: transform.width * 0.9,
    });
  };

  render() {
    const { className, align = 'right' } = this.props;
    const classes = cx(className, styles.edit, {
      [styles.alignLeft]: align === 'left',
      [styles.alignRight]: align !== 'left',
    });

    return (
      <div className={classes}>
        <div className={styles.inner}>
          <Button className={styles.button} onClick={this.rotate} title={kroostApp.strings.rotate}>
            <RotateIcon />
          </Button>
          <Button className={styles.button} onClick={this.flip} title={kroostApp.strings.mirror}>
            <FlipIcon />
          </Button>
          <Button className={styles.button} onClick={this.zoomIn} title={kroostApp.strings.zoomIn}>
            <ZoomInIcon />
          </Button>
          <Button className={styles.button} onClick={this.zoomOut} title={kroostApp.strings.zoomOut}>
            <ZoomOutIcon />
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/moment-edit/index.js